module.exports = "<div class=\"leftsettingbox\">\r\n        <ul class=\"list-unstyled settinglist\">    \r\n            <li><a [routerLink]=\"['consumerList']\"  routerLinkActive=\"selected\"><strong>Consumer List</strong></a></li>\r\n\r\n            <li><a [routerLink]=\"['consumerListLko']\"  routerLinkActive=\"selected\"><strong>Consumer List LKo</strong></a></li>\r\n         \r\n        </ul>     \r\n    </div>  \r\n      <div class=\"padding-zero\">      \r\n        <router-outlet></router-outlet>\r\n    </div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/kcc/consumer/consumer.component.html
// module id = ./src/app/crm/kcc/consumer/consumer.component.html
// module chunks = main